package org.zq.astrock_ai.ui.research.gushi.data

import org.zq.astrock_ai.ui.research.gushi.model.Candle
import org.zq.astrock_ai.ui.research.gushi.model.NewsItem
import org.zq.astrock_ai.ui.research.gushi.model.NewsType
import org.zq.astrock_ai.ui.research.gushi.model.StockItem
import org.zq.astrock_ai.ui.research.gushi.model.TrendDirection
import kotlin.math.sin

data class StockTrendMetrics(
    val status: String,
    val position: String,
    val resistance: String,
    val support: String,
    val upsideProb: String,
    val weakenProb: String,
    val riskLevel: String,
    val analysis: String,
    val adviceTitle: String,
    val positionDesc: String,
    val buyPlan: String,
    val riskHint: String,
)

object DemoData {

    val stocks = listOf(
        StockItem(
            name = "贤丰控股",
            code = "002141",
            marketCode = "002141.SZ",
            price = "5.73",
            changeAmount = "+0.52",
            changePercent = "+9.98%",
            direction = TrendDirection.UP,
            status = "涨停强势",
            note = "主力净流入",
            industry = "电子材料",
            tags = listOf("覆铜板", "兽用疫苗", "电子材料", "涨停"),
            sparkline = listOf(0.22f, 0.28f, 0.25f, 0.34f, 0.40f, 0.36f, 0.48f, 0.55f, 0.62f, 0.78f, 0.96f)
        ),
        StockItem(
            name = "永太科技",
            code = "002326",
            marketCode = "002326.SZ",
            price = "7.54",
            changeAmount = "+0.25",
            changePercent = "+3.42%",
            direction = TrendDirection.UP,
            status = "偏强",
            note = "资金流入",
            industry = "化学制品",
            tags = listOf("化学制品", "锂电池", "氟化工", "固态电池"),
            sparkline = listOf(0.26f, 0.22f, 0.34f, 0.28f, 0.42f, 0.38f, 0.54f, 0.46f, 0.62f, 0.55f, 0.72f)
        ),
        StockItem(
            name = "宁德时代",
            code = "300750",
            marketCode = "300750.SZ",
            price = "198.36",
            changeAmount = "-2.42",
            changePercent = "-1.21%",
            direction = TrendDirection.DOWN,
            status = "偏弱",
            note = "等待企稳",
            industry = "电池",
            tags = listOf("动力电池", "新能源", "储能"),
            sparkline = listOf(0.63f, 0.54f, 0.48f, 0.62f, 0.42f, 0.35f, 0.47f, 0.31f, 0.24f, 0.38f, 0.30f)
        ),
        StockItem(
            name = "贵州茅台",
            code = "600519",
            marketCode = "600519.SH",
            price = "1688.20",
            changeAmount = "+14.36",
            changePercent = "+0.86%",
            direction = TrendDirection.UP,
            status = "稳定上涨",
            note = "趋势平稳",
            industry = "白酒",
            tags = listOf("白酒", "消费", "沪股通"),
            sparkline = listOf(0.26f, 0.33f, 0.30f, 0.41f, 0.38f, 0.52f, 0.47f, 0.61f, 0.55f, 0.67f, 0.65f)
        ),
        StockItem(
            name = "中际旭创",
            code = "300308",
            marketCode = "300308.SZ",
            price = "124.65",
            changeAmount = "-3.12",
            changePercent = "-2.44%",
            direction = TrendDirection.DOWN,
            status = "偏弱",
            note = "波动扩大",
            industry = "通信设备",
            tags = listOf("CPO", "光模块", "人工智能"),
            sparkline = listOf(0.58f, 0.43f, 0.38f, 0.25f, 0.32f, 0.22f, 0.34f, 0.27f, 0.20f, 0.29f, 0.24f)
        ),
        StockItem(
            name = "东方财富",
            code = "300059",
            marketCode = "300059.SZ",
            price = "13.48",
            changeAmount = "+0.18",
            changePercent = "+1.35%",
            direction = TrendDirection.UP,
            status = "偏强",
            note = "成交活跃",
            industry = "证券",
            tags = listOf("证券", "互联网金融", "创业板"),
            sparkline = listOf(0.30f, 0.36f, 0.32f, 0.44f, 0.39f, 0.55f, 0.49f, 0.61f, 0.54f, 0.68f, 0.64f)
        )
    )

    val news = listOf(
        NewsItem(
            time = "10:32",
            type = NewsType.NEWS,
            title = "永太科技所属氟化工板块快速上涨",
            source = "同花顺财经",
            impact = "偏利好"
        ),
        NewsItem(
            time = "09:48",
            type = NewsType.CAPITAL,
            title = "主力资金净流入增加",
            source = "东方财富",
            impact = "偏利好"
        ),
        NewsItem(
            time = "昨天 18:26",
            type = NewsType.ANNOUNCEMENT,
            title = "公司发布关于项目进展的公告",
            source = "深交所",
            impact = "中性"
        ),
        NewsItem(
            time = "昨天 15:40",
            type = NewsType.RESEARCH,
            title = "某机构调整公司盈利预测",
            source = "中信证券",
            impact = "偏利好"
        )
    )

    private val xianfengNews = listOf(
        NewsItem(
            time = "15:00",
            type = NewsType.NEWS,
            title = "贤丰控股涨停收报 5.73 元，换手率约 17.85%",
            source = "行情播报",
            impact = "偏利好"
        ),
        NewsItem(
            time = "14:58",
            type = NewsType.CAPITAL,
            title = "主力资金净流入约 3.27 亿元，短线情绪高涨",
            source = "东方财富",
            impact = "偏利好"
        ),
        NewsItem(
            time = "07-21",
            type = NewsType.ANNOUNCEMENT,
            title = "公司发布股票交易异常波动公告",
            source = "深交所",
            impact = "中性"
        ),
        NewsItem(
            time = "04-22",
            type = NewsType.NEWS,
            title = "2025 年营收 11.56 亿同比大增，归母净利扭亏",
            source = "年报摘要",
            impact = "偏利好"
        ),
    )

    fun newsFor(stock: StockItem): List<NewsItem> = when (stock.code) {
        "002141" -> xianfengNews
        else -> listOf(
            NewsItem(
                time = "盘中",
                type = NewsType.NEWS,
                title = "${stock.name}最新报 ${stock.price}（${stock.changePercent}）",
                source = "行情",
                impact = if (stock.direction == TrendDirection.UP) "偏利好" else "中性",
            ),
            NewsItem(
                time = "盘中",
                type = NewsType.CAPITAL,
                title = if (stock.direction == TrendDirection.UP) "短线资金偏向流入" else "短线资金偏向观望",
                source = "资金流向",
                impact = if (stock.direction == TrendDirection.UP) "偏利好" else "中性",
            ),
            NewsItem(
                time = "近期",
                type = NewsType.ANNOUNCEMENT,
                title = "${stock.name}所属${stock.industry}板块动态更新",
                source = "公告/资讯",
                impact = "中性",
            ),
            NewsItem(
                time = "近期",
                type = NewsType.RESEARCH,
                title = "结合量价与均线位置评估${stock.name}短线节奏",
                source = "股势研究",
                impact = "中性",
            ),
        )
    }

    fun trendMetrics(stock: StockItem): StockTrendMetrics = when (stock.code) {
        "002141" -> StockTrendMetrics(
            status = "涨停强势",
            position = "情绪高潮区",
            resistance = "5.73",
            support = "5.21",
            upsideProb = "38%",
            weakenProb = "47%",
            riskLevel = "偏高",
            analysis = "趋势分析：贤丰控股今日涨停，短线情绪与资金驱动明显；但换手偏高、近期多次异常波动提示，且估值（市盈率）极高、扣非仍承压，涨停价追高盈亏比不佳。更宜观察打开涨停后的回踩，看 5.21～5.30 能否缩量承接。",
            adviceTitle = "观望，不追涨停",
            positionDesc = "股价处于短线加速后的情绪高潮区，已贴近涨停板，短线风险收益比偏弱。",
            buyPlan = "方案一：等待打开涨停后回踩 5.21～5.30，观察是否缩量企稳。\n方案二：若连续强势，等回踩不破 5.00 再分批试探，仓位宜轻。",
            riskHint = "失效点 4.87；高换手后容易剧烈震荡；扣非利润仍为负，基本面修复需持续验证。",
        )
        else -> StockTrendMetrics(
            status = if (stock.direction == TrendDirection.UP) "偏强上涨" else "偏弱整理",
            position = if (stock.direction == TrendDirection.UP) "中位突破区" else "回调观察区",
            resistance = "7.82",
            support = "7.28",
            upsideProb = if (stock.direction == TrendDirection.UP) "64%" else "41%",
            weakenProb = if (stock.direction == TrendDirection.UP) "23%" else "46%",
            riskLevel = "中等",
            analysis = "趋势分析：当前股价呈现${if (stock.direction == TrendDirection.UP) "向上转强" else "震荡偏弱"}迹象，接近关键压力位附近，短期上行动能面临考验。不宜立即追高，建议等待回踩确认支撑或放量突破压力后的回踩确认机会。",
            adviceTitle = "等待，不追高",
            positionDesc = "股价处于短期上涨后的压力区域，距离前期高点较近。",
            buyPlan = "方案一：等待回踩，观察 7.20～7.35 区域能否企稳。\n方案二：放量突破 7.82 后，等待回踩不破再考虑。",
            riskHint = "暂不适合买入：成交量快速萎缩；板块整体转弱；收盘跌破 7.05。",
        )
    }

    fun candles(seed: Int = 0, baseClose: Double = 5.18): List<Candle> {
        val result = mutableListOf<Candle>()
        val scale = baseClose / 5.18
        var previousClose = (5.22 + seed * 0.01) * scale * 0.85
        val dates = tradingDates(62)

        repeat(62) { index ->
            val trend = index * 0.040 * scale
            val wave = sin((index + seed) * 0.52) * 0.17 * scale
            val acceleration = if (index > 38) (index - 38) * 0.012 * scale else 0.0
            val close = baseClose * 0.72 + trend + wave + acceleration
            val open = previousClose + sin(index * 0.91 + seed) * 0.08 * scale
            val high = maxOf(open, close) + (0.08 + (index % 4) * 0.015) * scale
            val low = minOf(open, close) - (0.08 + (index % 3) * 0.012) * scale
            val volumeBase = 90.0 + (index % 8) * 10.0 + kotlin.math.abs(sin(index * 0.66)) * 90.0
            val volume = if (index in 48..51 || index > 58) volumeBase * 1.8 else volumeBase

            result += Candle(
                open = open,
                high = high,
                low = low,
                close = close,
                volume = volume,
                date = dates.getOrElse(index) { "" },
            )
            previousClose = close
        }

        // 让最后一根更贴近最新价，便于对照盘面
        val last = result.last()
        result[result.lastIndex] = last.copy(
            close = baseClose,
            high = maxOf(last.high, baseClose),
            open = last.open,
        )

        return result
    }

    fun candlesForPeriod(
        period: org.zq.astrock_ai.api.ChartPeriod,
        seed: Int,
        baseClose: Double,
    ): List<Candle> = when (period) {
        org.zq.astrock_ai.api.ChartPeriod.INTRADAY -> intradayCandles(seed, baseClose, points = 240, days = 1)
        org.zq.astrock_ai.api.ChartPeriod.FIVE_DAY -> intradayCandles(seed, baseClose, points = 240 * 5, days = 5)
        org.zq.astrock_ai.api.ChartPeriod.WEEK -> candles(seed, baseClose).takeLast(52)
        org.zq.astrock_ai.api.ChartPeriod.MONTH -> candles(seed + 3, baseClose).takeLast(36)
        else -> candles(seed, baseClose)
    }

    private fun intradayCandles(
        seed: Int,
        baseClose: Double,
        points: Int,
        days: Int,
    ): List<Candle> {
        val result = mutableListOf<Candle>()
        var price = baseClose * 0.985
        var avgSum = 0.0
        repeat(points) { index ->
            val day = index / (points / days).coerceAtLeast(1)
            val minuteOfDay = index % (points / days).coerceAtLeast(1)
            val hour = 9 + (minuteOfDay + 30) / 60
            val minute = (minuteOfDay + 30) % 60
            val wave = sin((index + seed) * 0.18) * baseClose * 0.008
            val drift = (index.toDouble() / points) * baseClose * 0.012
            price = (baseClose * 0.985 + wave + drift).coerceAtLeast(baseClose * 0.92)
            avgSum += price
            val avg = avgSum / (index + 1)
            val open = result.lastOrNull()?.close ?: price
            result += Candle(
                open = open,
                high = maxOf(open, price, avg),
                low = minOf(open, price, avg),
                close = price,
                volume = 40.0 + kotlin.math.abs(sin(index * 0.4)) * 120.0,
                date = "2026-07-${(24 + day).toString().padStart(2, '0')} ${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}",
                avg = avg,
            )
        }
        if (result.isNotEmpty()) {
            result[result.lastIndex] = result.last().copy(close = baseClose, high = maxOf(result.last().high, baseClose))
        }
        return result
    }

    /** 演示 K 线的横轴日期：自锚点日往前取 count 个工作日，返回升序 yyyy-MM-dd。 */
    private fun tradingDates(count: Int): List<String> {
        val dates = ArrayDeque<String>()
        var day = daysFromCivil(ANCHOR_YEAR, ANCHOR_MONTH, ANCHOR_DAY)
        while (dates.size < count) {
            // 1970-01-01 为星期四，据此换算：0=周日、6=周六
            val weekday = ((day + 4) % 7 + 7) % 7
            if (weekday in 1..5) {
                val (year, month, date) = civilFromDays(day)
                dates.addFirst(
                    "$year-${month.toString().padStart(2, '0')}-${date.toString().padStart(2, '0')}",
                )
            }
            day -= 1
        }
        return dates.toList()
    }

    private fun daysFromCivil(year: Int, month: Int, day: Int): Long {
        val y = year - if (month <= 2) 1 else 0
        val era = (if (y >= 0) y else y - 399) / 400
        val yearOfEra = y - era * 400
        val dayOfYear = (153 * (month + (if (month > 2) -3 else 9)) + 2) / 5 + day - 1
        val dayOfEra = yearOfEra * 365L + yearOfEra / 4 - yearOfEra / 100 + dayOfYear
        return era * 146097L + dayOfEra - 719468L
    }

    private fun civilFromDays(days: Long): Triple<Int, Int, Int> {
        val z = days + 719468L
        val era = (if (z >= 0) z else z - 146096) / 146097
        val dayOfEra = z - era * 146097
        val yearOfEra = (dayOfEra - dayOfEra / 1460 + dayOfEra / 36524 - dayOfEra / 146096) / 365
        val dayOfYear = dayOfEra - (365 * yearOfEra + yearOfEra / 4 - yearOfEra / 100)
        val monthPrime = (5 * dayOfYear + 2) / 153
        val day = (dayOfYear - (153 * monthPrime + 2) / 5 + 1).toInt()
        val month = (monthPrime + if (monthPrime < 10) 3 else -9).toInt()
        val year = (yearOfEra + era * 400 + if (month <= 2) 1 else 0).toInt()
        return Triple(year, month, day)
    }

    private const val ANCHOR_YEAR = 2026
    private const val ANCHOR_MONTH = 7
    private const val ANCHOR_DAY = 29
}
